const CHATBOT_SIDEBAR_KEYS = {
    AUTO_HIDE: 'u.chatbot.autoHide',
} as const;

export function getChatbotAutoHide(): boolean {
    return localStorage.getItem(CHATBOT_SIDEBAR_KEYS.AUTO_HIDE) === 'true';
}

export function setChatbotAutoHide(enabled: boolean): void {
    localStorage.setItem(CHATBOT_SIDEBAR_KEYS.AUTO_HIDE, String(enabled));
}
